import { z } from 'zod/v4'
import { ContactCreateCommandSchema } from './commands/contact.create.schema'
import { ContactResolveCommandSchema } from './commands/contact.resolve.schema'
import { ContactSignalCreateCommandSchema } from './commands/contact.signal.create.schema'
import { ContactGetAssociationsCommandSchema } from './commands/contact.getAssociations.schema'
import { MessagesFindCommandSchema } from './commands/messages.find.schema'

// Conversations service schema
export const ConversationsServiceSchema = z.union([
  ContactCreateCommandSchema,
  ContactResolveCommandSchema,
  ContactSignalCreateCommandSchema,
  ContactGetAssociationsCommandSchema,
  MessagesFindCommandSchema,
])

// Conversations service types
export type ConversationsService = z.infer<typeof ConversationsServiceSchema>
